<template>
    <b-row>
        <!-- MENSAGENS -->

        <mensagens-dash
            :qtd="qtdMensagensNaoLidas"
            :loading="loading"
            v-if="$temAcessoView('MENSAGENS-00')"
        ></mensagens-dash>

        <!-- PAGAMENTOS GERAIS -->

        <pagamentos-dash
            :qtd="qtdPagamentosProgramados"
            :loading="loading"
            v-if="$temAcessoView('FORN-PAG-00')"
        ></pagamentos-dash>

        <!-- GESCON FORNECEDORES -->
        <contratos-dash
            v-if="$temAcessoView('FORN-CONTRATOS-00')"
        ></contratos-dash>
        <gescon-pagamentos-dash
            v-if="$temAcessoView('GESCON-FORN-PAG-00')"
        ></gescon-pagamentos-dash>

        <!-- GESCON GESTORES -->
        <gescon-gestores-contratos-dash
            v-if="$temAcessoView('GESCON-GEST-CONT-00')"
        >
        </gescon-gestores-contratos-dash>
        <gescon-gestores-requisicoes-dash
            v-if="$temAcessoView('GESCON-GEST-REQ-00')"
        >
        </gescon-gestores-requisicoes-dash>
        <gescon-gestores-pagamentos-dash
            v-if="$temAcessoView('GESCON-GEST-PAG-00')"
        >
        </gescon-gestores-pagamentos-dash>

        <!-- GESCON GERENTES -->
        <gescon-gerentes-contratos-dash
            v-if="$temAcessoView('GESCON-GER-CONT-00')"
        >
        </gescon-gerentes-contratos-dash>
        <gescon-gerentes-requisicoes-dash
            v-if="$temAcessoView('GESCON-GER-REQ-00')"
        >
        </gescon-gerentes-requisicoes-dash>
        <gescon-gerentes-pagamentos-dash
            v-if="$temAcessoView('GESCON-GER-PAG-00')"
        >
        </gescon-gerentes-pagamentos-dash>

        <!-- GESCON UFI -->
        <gescon-financeiro-pagamentos
            :qtd="qtdPagamentosEmAnaliseGescon"
            :loading="loading"
            v-if="$temAcessoView('GESCON-UFI-PAG-00')"
        ></gescon-financeiro-pagamentos>

        <!-- GESCON APROVADORES -->

        <gescon-comprometimentos-aprovador
            :qtd="qtdComprometimentosEmAnaliseGescon"
            :loading="loading"
            v-if="$temAcessoView('GESCON-COMP-APROV-00')"
        ></gescon-comprometimentos-aprovador>

        <!-- SGF FORNECEDORES -->

        <credenciado-contratacoes-dash
            v-if="$temAcessoView('CRED-FORN-CONT-00')"
        ></credenciado-contratacoes-dash>
        <credenciado-finalizacoes-dash
            v-if="$temAcessoView('CRED-FORN-FIN-00')"
        ></credenciado-finalizacoes-dash>

        <!-- SGF GESTOR -->

        <gestores-contratacoes-dash
            v-if="$temAcessoView('CRED-GEST-CONT-00')"
        ></gestores-contratacoes-dash>
        <gestores-entregas-dash
            v-if="$temAcessoView('CRED-GEST-ENTR-00')"
        ></gestores-entregas-dash>
        <gestores-solicitacoes-aditivos
            v-if="$temAcessoView('CRED-GEST-ADIT-00')"
        ></gestores-solicitacoes-aditivos>
        <sgf-gestores-entregas-solicitacoes-reaberturas
            v-if="$temAcessoView('CRED-GEST-ENTR-06')"
        ></sgf-gestores-entregas-solicitacoes-reaberturas>
        <gestores-painel-erros-comprometimentos-dash
            v-if="$temAcessoView('CRED-GEST-PNL-01')"
        ></gestores-painel-erros-comprometimentos-dash>
        <gestores-contratacoes-sem-avaliacao-dash
            :qtd="qtdContratacoesSemAvaliacao"
            v-if="$temAcessoView('CRED-GEST-ENTR-00')"
        ></gestores-contratacoes-sem-avaliacao-dash>
        <gestores-entregas-sem-comprometimento-dash
            :qtd="qtdEntregasSemComprometimento"
            v-if="$temAcessoView('CRED-GEST-ENTR-00')"
        ></gestores-entregas-sem-comprometimento-dash>
        <gestores-entregas-erro-comprometimento-dash
            :qtd="qtdEntregasErroComprometimento"
            v-if="$temAcessoView('CRED-GEST-ENTR-00')"
        ></gestores-entregas-erro-comprometimento-dash>
        <gestores-contratacoes-vencimento-01-dash
            :qtd="qtdContratacoesVencimentoEntre14e10Dias"
            v-if="$temAcessoView('CRED-GEST-CONT-00')"
        ></gestores-contratacoes-vencimento-01-dash>

        <!-- SGF GERENTES -->

        <gerentes-contratacoes-dash
            v-if="$temAcessoView('CRED-GER-CONT-00')"
        ></gerentes-contratacoes-dash>
        <gerentes-entregas-dash
            v-if="$temAcessoView('CRED-GER-ENTR-00')"
        ></gerentes-entregas-dash>
        <sgf-gerentes-entregas-solicitacoes-reaberturas
            v-if="$temAcessoView('CRED-GER-ENTR-02')"
            :qtd="qtdSolicitacoesReaberturasEmAnalisePeloGerente"
            :loading="loading"
        ></sgf-gerentes-entregas-solicitacoes-reaberturas>
        <gerentes-apoios-dash
            v-if="$temAcessoView('CRED-GER-APOIO-00')"
        ></gerentes-apoios-dash>
        <gestores-designados-dash
            v-if="$temAcessoView('CRED-GER-GEST-00')"
        ></gestores-designados-dash>

        <!-- SGF UABS -->

        <uabs-contratacoes-dash
            v-if="$temAcessoView('CRED-UABS-CONT-00')"
        ></uabs-contratacoes-dash>
        <uabs-finalizacoes-dash
            :qtd="qtdPagamentosEmAnaliseUabsSgf"
            :loading="loading"
            v-if="$temAcessoView('CRED-UABS-FIN-00')"
        ></uabs-finalizacoes-dash>
        <ufi-finalizacoes-dash
            :qtd="qtdPagamentosEmAnaliseUfiSgf"
            :loading="loading"
            v-if="$temAcessoView('CRED-UFI-FIN-00')"
        ></ufi-finalizacoes-dash>
        <uabs-solicitacoes-aditivos
            v-if="$temAcessoView('CRED-UABS-ADIT-00')"
            :qtd="qtdSolicitacoesAditivosEmProcessamento"
            :loading="loading"
        ></uabs-solicitacoes-aditivos>
        <sgf-uabs-entregas-solicitacoes-reaberturas
            :qtd="qtdSolicitacoesReaberturasEmAnalisePelaUabs"
            :loading="loading"
            v-if="$temAcessoView('CRED-UABS-ENTR-06')"
        ></sgf-uabs-entregas-solicitacoes-reaberturas>

        <!-- SGF APOIOS -->

        <apoios-contratacoes-dash
            v-if="$temAcessoView('CRED-APOIO-CONT-00')"
        ></apoios-contratacoes-dash>

        <!-- SGTEC FORNECEDORES -->

        <sgtec-projetos-dash
            v-if="$temAcessoView('SGTEC-FORN-PRJ-00')"
        ></sgtec-projetos-dash>
        <sgtec-pagamentos-dash
            v-if="$temAcessoView('SGTEC-FORN-PAG-00')"
        ></sgtec-pagamentos-dash>

        <!-- SGTEC GESTORES -->

        <sgtec-gestores-projetos-dash
            v-if="$temAcessoView('SGTEC-GEST-PRJ-00')"
        ></sgtec-gestores-projetos-dash>
        <sgtec-gestores-pagamentos-dash
            v-if="$temAcessoView('SGTEC-GEST-PAG-00')"
        ></sgtec-gestores-pagamentos-dash>

        <!-- SGTEC GERENTES -->

        <sgtec-gerentes-projetos-dash
            v-if="$temAcessoView('SGTEC-GER-PRJ-00')"
        ></sgtec-gerentes-projetos-dash>
        <sgtec-gerentes-pagamentos-dash
            v-if="$temAcessoView('SGTEC-GER-PAG-00')"
        ></sgtec-gerentes-pagamentos-dash>
        <sgtec-gerentes-apoios-dash
            v-if="$temAcessoView('SGTEC-GER-APOIO-00')"
        ></sgtec-gerentes-apoios-dash>

        <!-- SGTEC APOIOS -->

        <sgtec-apoios-projetos-dash
            v-if="$temAcessoView('SGTEC-APOIO-PRJ-00')"
        ></sgtec-apoios-projetos-dash>
        <sgtec-apoios-pagamentos-dash
            v-if="$temAcessoView('SGTEC-APOIO-PAG-00')"
        ></sgtec-apoios-pagamentos-dash>

        <!-- SGTEC UABS -->

        <sgtec-uabs-projetos-dash
            v-if="$temAcessoView('SGTEC-UABS-PRJ-00')"
        ></sgtec-uabs-projetos-dash>
        <sgtec-uabs-pagamentos-dash
            :qtd="qtdPagamentosEmAnaliseUabsSgtec"
            :loading="loading"
            v-if="$temAcessoView('SGTEC-UABS-PAG-00')"
        ></sgtec-uabs-pagamentos-dash>

        <!-- SGTEC UFI -->

        <sgtec-ufi-pagamentos-dash
            :qtd="qtdPagamentosEmAnaliseUfiSgtec"
            :loading="loading"
            v-if="$temAcessoView('SGTEC-UFI-PAG-00')"
        ></sgtec-ufi-pagamentos-dash>

        <!-- ADMINISTRACAO FORNECEDORES -->

        <dados-cadastrais-dash
            v-if="$temAcessoView('FORN-DADOS-00')"
        ></dados-cadastrais-dash>
        <certidoes-dash v-if="$temAcessoView('FORN-CERT-00')"></certidoes-dash>
        <fornecedores-dirfs-dash
            v-if="$temAcessoView('FORN-DIRF-00')"
        ></fornecedores-dirfs-dash>
        <fornecedores-usuarios-dash
            v-if="$temAcessoView('FORN-USR-00')"
        ></fornecedores-usuarios-dash>

        <!-- ADMINISTRACAO SEBRAE -->

        <fornecedores-dash
            v-if="$temAcessoView('GEST-FORNECEDORES-00')"
        ></fornecedores-dash>
        <atualizacoes-cadastrais-dash
            v-if="$temAcessoView('GEST-DADOS-00')"
            :qtd="qtdAtualizacoesCadastraisEmAprovacao"
            :loading="loading"
        ></atualizacoes-cadastrais-dash>
        <solicitacoes-acesso-dash
            v-if="$temAcessoView('CTRLACS-SOLACS-00')"
            :qtd="qtdSolicitacoesAcessoEmAprovacao"
            :loading="loading"
        ></solicitacoes-acesso-dash>
        <dirfs-dash v-if="$temAcessoView('DIRFS-00')"></dirfs-dash>
        <usuarios-dash v-if="$temAcessoView('CTRLACS-USR-00')"></usuarios-dash>
        <base-conhecimento-dash></base-conhecimento-dash>
        <pesquisas-dash
            titulo="PESQUISA DE USABILIDADE"
            :tipo="1"
        ></pesquisas-dash>
        <pesquisas-dash2
            v-if="$temAcessoView('PESQUISAS-00')"
        ></pesquisas-dash2>

        <!-- ESTATISTICAS -->

        <total-acessos
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdTotalAcessos"
        ></total-acessos>
        <total-acessos-ano
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdTotalAcessosAno"
        ></total-acessos-ano>
        <total-acessos-mes
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdTotalAcessosMes"
        ></total-acessos-mes>
        <novos-fornecedores-ano
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdNovosFornecedoresAno"
        ></novos-fornecedores-ano>
        <novos-fornecedores-mes
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdNovosFornecedoresMes"
        ></novos-fornecedores-mes>
        <solicitacoes-acesso-ano-dash
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdSolicitacoesAcessoAno"
        ></solicitacoes-acesso-ano-dash>
        <solicitacoes-acesso-mes-dash
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdSolicitacoesAcessoMes"
        ></solicitacoes-acesso-mes-dash>
    </b-row>
</template>

<script>
import DashboardServicos from './DashboardServicos'

//Geral
import MensagensDash from './../mensagens/MensagensDash'
import BaseConhecimentoDash from './../baseconhecimento/BaseConhecimentoDash'
import PesquisasDash from './../pesquisas/PesquisasDash'
import PesquisasDash2 from './../pesquisas/PesquisasDash2'

// Fornecedores
import PagamentosDash from './../fornecedor/pagamentos/PagamentosDash'
import DadosCadastraisDash from './../fornecedor/dadoscadastrais/DadosCadastraisDash'
import ContratosDash from './../fornecedor/contratos/ContratosDash'
import FornecedoresDirfsDash from './../fornecedor/dirfs/DirfsDash'
import FornecedoresUsuariosDash from './../fornecedor/usuarios/UsuariosDash'
import CertidoesDash from './../fornecedor/certidoes/CertidoesDash'
import GesconPagamentosDash from '../fornecedor/contratos/pagamentos/PagamentosDash'

// Gestao
import AtualizacoesCadastraisDash from './../atualizacoescadastrais/AtualizacoesCadastraisDash'
import SolicitacoesAcessoDash from './../ctrlacesso/solicitacoesacesso/SolicitacoesAcessoDash'
import DirfsDash from './../dirfs/DirfsDash'
import UsuariosDash from './../ctrlacesso/usuarios/UsuariosDash'
import FornecedoresDash from './../fornecedores/FornecedoresDash'
import TotalAcessos from './../ctrlacesso/login/TotalAcessosDash'
import TotalAcessosAno from './../ctrlacesso/login/TotalAcessosAnoDash'
import TotalAcessosMes from './../ctrlacesso/login/TotalAcessosMesDash'
import NovosFornecedoresAno from './NovosFornecedoresAnoDash'
import NovosFornecedoresMes from './NovosFornecedoresMesDash'
import SolicitacoesAcessoAnoDash from './SolicitacoesAcessoAnoDash'
import SolicitacoesAcessoMesDash from './SolicitacoesAcessoMesDash'
import GesconComprometimentosAprovador from '../gescon/aprovadores/ComprometimentosDash'
import GesconFinanceiroPagamentos from '../gescon/financeiro/pagamentos/PagamentosDash'

//GESCON
import GesconGestoresContratosDash from '../gescon/gestores/contratos/ContratosDash'
import GesconGestoresRequisicoesDash from '../gescon/gestores/requisicoes/RequisicoesDash'
import GesconGestoresPagamentosDash from '../gescon/gestores/pagamentos/PagamentosDash'
import GesconGerentesContratosDash from '../gescon/gerentes/contratos/ContratosDash'
import GesconGerentesRequisicoesDash from '../gescon/gerentes/requisicoes/RequisicoesDash'
import GesconGerentesPagamentosDash from '../gescon/gerentes/pagamentos/PagamentosDash'

export default {
    components: {
        PagamentosDash,
        DadosCadastraisDash,
        ContratosDash,
        FornecedoresDirfsDash,
        FornecedoresUsuariosDash,
        FornecedoresDash,
        AtualizacoesCadastraisDash,
        SolicitacoesAcessoDash,
        DirfsDash,
        UsuariosDash,
        CertidoesDash,
        TotalAcessos,
        TotalAcessosAno,
        TotalAcessosMes,
        NovosFornecedoresAno,
        NovosFornecedoresMes,
        SolicitacoesAcessoAnoDash,
        SolicitacoesAcessoMesDash,
        MensagensDash,
        BaseConhecimentoDash,
        PesquisasDash,
        PesquisasDash2,
        GesconComprometimentosAprovador,
        GesconPagamentosDash,
        GesconFinanceiroPagamentos,
        GesconGestoresContratosDash,
        GesconGestoresRequisicoesDash,
        GesconGestoresPagamentosDash,
        GesconGerentesContratosDash,
        GesconGerentesRequisicoesDash,
        GesconGerentesPagamentosDash
    },

    data() {
        return {
            loading: false,
            qtdSolicitacoesAcessoEmAprovacao: 0,
            qtdAtualizacoesCadastraisEmAprovacao: 0,
            qtdPagamentosProgramados: 0,
            qtdTotalAcessos: 0,
            qtdTotalAcessosAno: 0,
            qtdTotalAcessosMes: 0,
            qtdNovosFornecedoresAno: 0,
            qtdNovosFornecedoresMes: 0,
            qtdSolicitacoesAcessoAno: {},
            qtdSolicitacoesAcessoMes: {},
            qtdMensagensNaoLidas: 0,
            qtdContratacoesSemAvaliacao: 0,
            qtdEntregasSemComprometimento: 0,
            qtdEntregasErroComprometimento: 0,
            qtdContratacoesVencimentoEntre14e10Dias: 0,
            qtdSolicitacoesAditivosEmProcessamento: 0,
            qtdSolicitacoesReaberturasEmAnalisePeloGerente: 0,
            qtdSolicitacoesReaberturasEmAnalisePelaUabs: 0,
            qtdPagamentosEmAnaliseGescon: 0,
            qtdComprometimentosEmAnaliseGescon: 0,
            qtdPagamentosEmAnaliseUabsSgf: 0,
            qtdPagamentosEmAnaliseUfiSgf: 0,
            qtdPagamentosEmAnaliseUabsSgtec: 0,
            qtdPagamentosEmAnaliseUfiSgtec: 0
        }
    },

    methods: {
        obterDashboard() {
            this.loading = true
            DashboardServicos.obterDashboard().then((response) => {
                if (response) {
                    if (response.success) {
                        this.qtdSolicitacoesAcessoEmAprovacao =
                            response.data.QtdSolicitacoesAcessoEmAprovacao
                        this.qtdAtualizacoesCadastraisEmAprovacao =
                            response.data.QtdAtualizacoesCadastraisEmAprovacao
                        this.qtdPagamentosProgramados =
                            response.data.QtdPagamentosProgramados
                        this.qtdTotalAcessos = response.data.QtdTotalAcessos
                        this.qtdTotalAcessosAno =
                            response.data.QtdTotalAcessosAno
                        this.qtdTotalAcessosMes =
                            response.data.QtdTotalAcessosMes
                        this.qtdNovosFornecedoresAno =
                            response.data.QtdNovosFornecedoresAno
                        this.qtdNovosFornecedoresMes =
                            response.data.QtdNovosFornecedoresMes
                        this.qtdSolicitacoesAcessoAno = {
                            total: response.data.QtdSolicitacoesAcessoAno,
                            aprovadas:
                                response.data.QtdSolicitacoesAcessoAnoAprovadas,
                            reprovadas:
                                response.data.QtdSolicitacoesAcessoAnoReprovadas
                        }
                        this.qtdSolicitacoesAcessoMes = {
                            total: response.data.QtdSolicitacoesAcessoMes,
                            aprovadas:
                                response.data.QtdSolicitacoesAcessoMesAprovadas,
                            reprovadas:
                                response.data.QtdSolicitacoesAcessoMesReprovadas
                        }
                        this.qtdMensagensNaoLidas =
                            response.data.QtdMensagensNaoLidas

                        this.qtdContratacoesSemAvaliacao =
                            response.data.QtdContratacoesSemAvaliacao
                        this.qtdEntregasSemComprometimento =
                            response.data.QtdEntregasSemComprometimento
                        this.qtdEntregasErroComprometimento =
                            response.data.QtdEntregasErroComprometimento
                        this.qtdContratacoesVencimentoEntre14e10Dias =
                            response.data.QtdContratacoesVencimentoEntre14e10Dias
                        this.qtdSolicitacoesAditivosEmProcessamento =
                            response.data.QtdSolicitacoesAditivosEmProcessamento
                        this.qtdSolicitacoesReaberturasEmAnalisePeloGerente =
                            response.data.QtdSolicitacoesReaberturasEmAnalisePeloGerente
                        this.qtdSolicitacoesReaberturasEmAnalisePelaUabs =
                            response.data.QtdSolicitacoesReaberturasEmAnalisePelaUabs
                        this.qtdPagamentosEmAnaliseGescon =
                            response.data.QtdPagamentosEmAnaliseGescon
                        this.qtdComprometimentosEmAnaliseGescon =
                            response.data.QtdComprometimentosEmAnaliseGescon
                        this.qtdPagamentosEmAnaliseUabsSgf =
                            response.data.QtdPagamentosEmAnaliseUabsSgf
                        this.qtdPagamentosEmAnaliseUfiSgf =
                            response.data.QtdPagamentosEmAnaliseUfiSgf
                        this.qtdPagamentosEmAnaliseUabsSgtec =
                            response.data.QtdPagamentosEmAnaliseUabsSgtec
                        this.qtdPagamentosEmAnaliseUfiSgtec =
                            response.data.QtdPagamentosEmAnaliseUfiSgtec
                    }
                }
                this.loading = false
            })
        }
    },

    created() {
        this.obterDashboard()
    }
}
</script>
